import { ChannelTypes } from "./core";

export enum AssetType {
	SenderId = 'sender',
	SmsTemplate = 'sms-template',
	DidNumbers = 'did-number',
	// KycDocs = 'kyc',
}

export enum AssetTypeWhatsapp {
	WaNumbers = 'wa-number',
	WhatsappTemplate = 'wa-template',
}
export interface IAssets {
	sender: IAssetDataObject;
	did_number: IAssetDataObject;
	wa_number: IAssetDataObject;
	sms_template: IAssetDataObject;
	kyc_document: IAssetDataObject;
	wa_template: IAssetDataObject;
	channel_status: ChannelTypes;
}

export type AlertStatusType =
	| 'Approved'
	| 'Under Review'
	| 'Others'
	| 'Rejected'
	| 'Need Attention';

type AlertType = {
	message: string;
	status: AlertStatusType;
};

export interface IAssetDataObject {
	count: number;
	alert: AlertType;
	timestamp: string;
}

export type AssetsDetailedFilter = {
	asset: string;
	search: string;
};
